<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="internal" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>
        <section class="dp-right">
            <!-- 工具条 -->
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <div class="table-wrapper">
                                <el-table :data="tableData" v-loading="listLoading" class="custom-elegant-table"
                    header-row-class-name="elegant-table-header" row-class-name="elegant-table-row" style="width: 100%">

                    <el-table-column label="序号" width="60" align="center">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 + (page - 1) * pageSize }}
                        </template>
                    </el-table-column>

                    <el-table-column label="头像" width="90" align="center">
                        <template slot-scope="scope">
                            <div class="avatar-wrap">
                              <!-- OSS 私有桶：el-image 不能用 v-oss-src，改用 oss-el-image。最后修改：2026-09-14 -->
                              <oss-el-image
                                v-if="scope.row.Avatar"
                                class="teacher-avatar"
                                :src="scope.row.Avatar"
                                :preview-src-list="[scope.row.Avatar]"
                                fit="cover"
                              />
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="TeacherName" label="姓名" min-width="120"></el-table-column>
                    <el-table-column prop="DepartmentName" label="所属部门" min-width="120"></el-table-column>
                    <el-table-column prop="TeacherTypeStr" label="职务" min-width="100"></el-table-column>
                    <el-table-column label="班主任" min-width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.IsClassTeacher === 1 ? 'success' : 'info'" size="small">
                                {{ scope.row.IsClassTeacher === 1 ? '是' : '否' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <!-- 大屏模块显隐开关 -->
                    <el-table-column label="名特优教" width="120" align="center">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.IsFamous" active-color="#2563eb" inactive-color="#dcdfe6"
                                @change="handleSwitchChange(scope.row, 'IsFamous')">
                            </el-switch>
                        </template>
                    </el-table-column>

                    <el-table-column label="教师光荣榜" width="120" align="center">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.IsHonor" active-color="#2563eb" inactive-color="#dcdfe6"
                                @change="handleSwitchChange(scope.row, 'IsHonor')">
                            </el-switch>
                        </template>
                    </el-table-column>

                    <el-table-column label="教师形象墙" width="120" align="center">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.IsWall" active-color="#2563eb" inactive-color="#dcdfe6"
                                @change="handleSwitchChange(scope.row, 'IsWall')">
                            </el-switch>
                        </template>
                    </el-table-column>

                </el-table>
            </div>

            <!-- 分页区域 -->
            <el-col :span="24" class="toolbar">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                    :total="total" :current-page="page" :page-size="pageSize"
                    @current-change="handleCurrentChange" @size-change="handleSizeChange"
                    style="float: right">
                </el-pagination>
            </el-col>

        </section>
    </section>
</template>

<script>
import DepartmentPane from '../../../components/DepartmentPane'
import Toolbar from '../../../components/Toolbar'
import { getButtonList } from '../../../promissionRouter'
import { getTeacherInfo, saveTeacherPortraitConfig } from '../../../api/modules/personnel';
import { BaseApiUrl } from '../../../api/base';
import { getUnifiedPageSize } from '../../../utils/elPaginationUnify'

export default {
    name: 'TeacherProfileManage',
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            DepartmentId: 0,
            buttonList: [],
            searchList: [
                { label: '姓名', key: 'teacherName', width: '180px' },
                {
                    label: '名特优教师', key: 'isFamous', type: 'select', width: '130px',
                    options: [
                        { label: '全部', value: '' },
                        { label: '是', value: true },
                        { label: '否', value: false }
                    ]
                },
                {
                    label: '光荣榜', key: 'isHonor', type: 'select', width: '130px',
                    options: [
                        { label: '全部', value: '' },
                        { label: '是', value: true },
                        { label: '否', value: false }
                    ]
                },
                {
                    label: '形象墙', key: 'isWall', type: 'select', width: '130px',
                    options: [
                        { label: '全部', value: '' },
                        { label: '是', value: true },
                        { label: '否', value: false }
                    ]
                }
            ],
            filters: {},
            listLoading: false,
            total: 0,
            page: 1,
            pageSize: getUnifiedPageSize(),
            tableData: [],
            BaseApiUrl: BaseApiUrl,
            teacherMasterList: [],
            departmentList: [],
            courseList: [],
            isClassDept: false,
        };
    },
    mounted() {
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
    methods: {
        // 工具条按钮回调
        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = item.search;
            } else {
                this.filters = { key: item.search };
            }
            this[item.Func].apply(this, item);
        },
        treeNodeClick(data, node, component) {
            this.DepartmentId = data.value;
            this.isClassDept = data.DeptOrgType === "class" || data.DeptOrgType === "grade";
            this.page = 1;
            this.handleQuery();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.handleQuery();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.page = 1;
            this.handleQuery();
        },
        // 查询教师列表
        handleQuery() {
            let para = {
                page: this.page,
                intPageSize: this.pageSize,
                departmentId: this.DepartmentId,
                ...this.filters,
            };
            this.listLoading = true;
            getTeacherInfo(para).then((res) => {
                this.total = res.data.response.dataCount;
                this.tableData = res.data.response.data;
                this.listLoading = false;
            }).catch(() => {
                this.listLoading = false;
            });
        },
        handleSwitchChange(row, field) {
            let para = {
                teacherInfoId: row.Id,
                field: field,
                active: row[field]
            };
            saveTeacherPortraitConfig(para).then(res => {
                if (res.data.success) {
                    this.$message.success(res.data.msg);
                } else {
                    this.$message.error(res.data.msg);
                    row[field] = !row[field]; // 失败则回滚状态
                }
            }).catch(() => {
                row[field] = !row[field];
            });
        },
    }
}
</script>

<style scoped>
/* 让 dp-right 成为 flex 列容器，toolbar 和内容垂直排列 */
.dp-right {
    display: flex;
    flex-direction: column;
}

.avatar-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    margin: 0 auto;
}

.teacher-avatar {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #fff;
    background-color: #f8fafc;
}

.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f1f5f9;
    color: #cbd5e1;
}

.image-slot i {
    font-size: 24px;
}

.action-link {
    font-size: 14px;
    margin: 0 6px;
}

.action-link:hover {
    opacity: 0.8;
}
</style>
